// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oTAfs","toggleWrap":"styles_toggleWrap__2PXSJ","content":"styles_content__2OaTX","selectAreaCode":"styles_selectAreaCode__1s1te"};